import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Button, Card, Form, Modal } from 'react-bootstrap';
import { BiRupee } from 'react-icons/bi';
import { BsBellFill, BsTrashFill } from 'react-icons/bs';
import { IoWallet } from 'react-icons/io5';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { deleteNotification, getNotificationList, markAllAsReadNotification, markAsReadNotification } from '../../Redux/Notification/action';
import { addPaymentRazorpay, getWalletDetails, withdrawPayment } from '../../Redux/Wallet/action';
import { setUserLoginDetails } from '../../slices/user/userSlice';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import ToasterMessage from '../ToasterMessage';


const ViewNotification = () => {
    const dispatch = useDispatch()
    const users = useSelector((state) => state.user)

    const [walletTab, setWalletTab] = useState('add');
    const [toaster, setToaster] = useState("");
    const [notifications, setNotifications] = useState([])
    const [wallet, setWallet] = useState({});
    const [show, setShow] = useState(false);
    // const [update, setUpdate] = useState(false);
    const handleClose = () => setShow(false);

    const [amount, setamount] = useState('');
    const navigate = useNavigate()
    useEffect(() => {
        getNotifications()
    }, []);
    const onClickmarkAsRead = (notification) => {
        let pagetype = 'buyer'
        if (localStorage.getItem('user_type') == 2) {
            pagetype = 'seller'
        }
        let id = notification.id
        markAsReadNotification({ id })((response) => {
            if (response && response.status) {
                getNotifications()

            }
        });
        if (notification?.type == 1) {
            handleShow()
        }
        else if (notification?.type == 2) {
            if (notification?.task_status?.status == "1") {

                navigate(`/mytasklisting${pagetype}`, { state: { data: notification.task_status } })
            }
            else if (notification?.task_status?.status == "2") {
                navigate(`/mytaskassigned${pagetype}`, { state: { data: notification.task_status } })
            }
            else {
                navigate(`/mytaskcompleted${pagetype}`, { state: { data: notification } })
            }
        }
        else {

        }

    }
    const onClickmarkAllAsRead = () => {

        markAllAsReadNotification()((response) => {
            if (response && response.status) {
                // dispatch(
                //     setUserLoginDetails({
                //         ...users,
                //         notificationCount: null

                //     })
                // )
                getNotifications()
            }
        });
    }
    const handleShow = () => {
        getWalletDetails()((response) => {
            if (response && response.status) {
                setWallet(response?.data?.data)
                setShow(true);
            }


        });
    }
    const getNotifications = () => {
        getNotificationList(9, '', page)((response) => {
            if (response && response.status) {
                setNotifications(response?.data)
                if ((notifications.length + response?.data?.length) >= response?.total_count) {
                    setHasMore(false)
                }
                setPage(2)
            }
        });
    }
    const onClickDeleteNotification = (id) => {
        deleteNotification({ id: [id] })((response) => {
            if (response && response.status) {
                getNotifications()
            }
        });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (amount === "") {
            alert("please enter amount");
        } else {
            var options = {
                key: "rzp_test_StpZ79oxZLF6Qx",
                key_secret: "jm8zFJlipyTf4uBITiMDVhxK",
                amount: amount * 100,
                currency: "INR",
                name: "STARTUP_PROJECTS",
                description: "for testing purpose",
                handler: function (response) {

                    addPaymentRazorpay(response.razorpay_payment_id, amount)((response) => {
                        if (response && response.status) {
                            getWalletDetails()((response) => {
                                if (response && response.status) {
                                    setWallet(response?.data?.data)
                                    setShow(false);
                                    setamount("")

                                }
                                setToaster("Sucessfully Added")
                                setTimeout(() => {
                                    setToaster("")

                                }, 2000);


                            });
                        }
                    });
                    // alert(response.razorpay_payment_id);
                },
                prefill: {
                    name: "Velmurugan",
                    email: "mvel1620r@gmail.com",
                    contact: "7904425033"
                },
                notes: {
                    address: "Razorpay Corporate office"
                },
                theme: {
                    color: "#3399cc"
                }
            };
            var pay = new window.Razorpay(options);
            pay.open();
        }
    }
    const withdrawAmount = (e) => {
        e.preventDefault()

        withdrawPayment(amount)((response) => {
            if (response && response.status) {
                getWalletDetails()((response) => {
                    if (response && response.status) {
                        setWallet(response?.data?.data)
                        setShow(false);
                        setamount("")
                    }
                    setToaster("Success")
                    setTimeout(() => {
                        setToaster("")

                    }, 2000);


                });
            } else {
                alert(response?.response?.data?.message)
            }
        });
    }
    const handleWalletTab = (name) => {
        setWalletTab(name)
    }
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)

    const paginate = () => {

        getNotificationList(9, '', page)((response) => {
            if (response.status) {

                if ((notifications.length + response?.data?.length) >= response?.total_count) {
                    setHasMore(false)
                }
                setNotifications(notifications.concat(response?.data))
            }
            else {

                setHasMore(false)
            }
        })
        setPage(page + 1)
    }
    return (
        <React.Fragment>
            <Header />
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    View Notification </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name">  View Notification</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='mynotify-all'>
                <div className="container">
                    <div className="row">
                        {/* <div className="col-lg-3 left">
                            <div className="box shadow-sm mb-3 rounded bg-white ads-box text-center">
                                <img src="https://bootdey.com/img/Content/avatar/avatar7.png" className="img-fluid" alt="Responsive" />
                                <div className="p-3 border-bottom">
                                    <h6 className="font-weight-bold text-dark">Notifications</h6>
                                    <p className="mb-0 text-muted">You’re all caught up! Check back later for new notifications</p>
                                </div>
                            </div>

                        </div> */}

                        <div className="col-lg-12 right">
                            <h2 className="text-center mb-5">My Notifications</h2>
                            <div className="btn-group">
                                <div className='text-end p-2'>
                                    <Button variant="outline-success" onClick={() => onClickmarkAllAsRead()}>Mark all as read</Button>
                                </div>
                                {/* <div className='text-end p-2'>
                                    <Button variant="outline-danger">Delete all</Button>
                                </div> */}
                            </div>
                            <div className="box shadow-sm rounded bg-white mb-3">
                                <div className="box-title border-bottom p-3">
                                    <h6 className="m-0">Notifications</h6>
                                </div>
                                <InfiniteScroll
                                    dataLength={notifications.length}
                                    next={paginate}
                                    hasMore={hasMore}
                                    loader={<p style={{ textAlign: 'center' }}>
                                        <b>Loading...</b>
                                    </p>}
                                    endMessage={
                                        <p style={{ textAlign: 'center' }}>
                                            <b>Yay! You have seen it all</b>
                                        </p>
                                    }
                                >
                                    <div className="box-body p-0">

                                        {notifications?.map((notification, index) =>

                                            <div className={notification?.is_read == true ? "notification-view_unread border-bottom osahan-post-header" : "notification-view_read border-bottom osahan-post-header"} key={index} >
                                                <div className='row'>
                                                    <div className='col-lg-2'>
                                                        <div onClick={() => onClickmarkAsRead(notification)} style={{ cursor: "pointer" }}>
                                                            <div className=' d-flex align-items-center'>
                                                                <div className="dropdown-list-image mr-3">
                                                                    <BsBellFill size="30" />
                                                                </div>
                                                                <div className="font-weight-bold mr-3 p-2">
                                                                    <div className="text-truncate">{notification?.title}</div>
                                                                    {/* <div className="small">Income tax sops on the cards, The bias in VC funding, and other top news for you</div> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="ml-auto mb-auto">
                                                    {/* <div className="btn-group">
                                                    <div className='text-end p-2'>
                                                        {!notification?.is_read &&
                                                            <Button variant="outline-success" onClick={() => onClickmarkAsRead(notification?.id)}>Mark as read</Button>
                                                        }
                                                    </div>
                                                </div> */}


                                                    <div className="btn-group">
                                                        <div className='text-end p-2'>

                                                            <Button variant="outline-danger" onClick={() => onClickDeleteNotification(notification?.id)}><BsTrashFill /></Button>
                                                        </div>
                                                    </div>
                                                    <br />

                                                </span>
                                            </div>
                                        )}



                                    </div>
                                </InfiniteScroll>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <Modal
                className='wallet-balance-modal'
                show={show}
                onHide={handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div>
                        <h5> Wallet Balance</h5>
                    </div>
                    <Card className='wallet-balance mt-3'>
                        <Card.Body>
                            <div className='wallet-balance-icon'>
                                <div className='wallet-balance-amount'>
                                    <BiRupee size="40" style={{ color: "#000" }} /><h6>{parseFloat(wallet?.wallet_balance ? wallet?.wallet_balance : 0).toFixed(2)}</h6>
                                </div>
                                <IoWallet size="50" style={{ color: "#1cbbee" }} />
                            </div>
                            <div className="switches-container mb-4">
                                <input id='addWallet' onClick={() => { handleWalletTab('add') }} type="radio" name="type_of_user" value="1" checked={walletTab == 'add' ? true : false} />
                                <input id='withdrawWallet' type="radio" name="type_of_user" onClick={() => { handleWalletTab('withdraw') }} value="2" checked={walletTab == 'withdraw' ? true : false} />
                                <label for="addWallet">Add</label>
                                <label for="withdrawWallet">Withdraw</label>
                                <div className="switch-wrapper">
                                    <div className="switch">
                                        <div>Add</div>
                                        <div>Withdraw</div>
                                    </div>
                                </div>
                            </div>
                            <div className='withdraw-money mt-5'>
                                {walletTab == 'add' ?
                                    <h5>Add Money</h5>
                                    :
                                    <h5>Withdraw Money</h5>
                                }
                                <Form>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <div className='withdraw'>
                                            <BiRupee size="20" style={{ color: "#000" }} className='withdraw-icon' />
                                            <Form.Control type="text" value={amount} onChange={(e) => setamount(e.target.value)} placeholder="0" />
                                        </div>
                                    </Form.Group>
                                    <div className='withdraw-btn mt-5'>
                                        {walletTab == 'add' ?
                                            <button className="btn btn-primary" onClick={handleSubmit}>Add</button>
                                            :
                                            <button className="btn btn-primary" onClick={(e) => withdrawAmount(e)}>Withdraw</button>
                                        }
                                    </div>
                                </Form>
                            </div>

                        </Card.Body>
                    </Card>

                    {/* 
                                                            <Card className='withdraw-money mt-5'>
                                                                <Card.Body>

                                                                </Card.Body>
                                                            </Card> */}
                </Modal.Body>
            </Modal>
            <Footer />
        </React.Fragment>
    )
}

export default ViewNotification;